/**
 * @prettier
 */

import React from 'react';
import { Banner } from '@zola/zola-ui';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import SamplePreview from '../SamplePreview/SamplePreview';
import Layout from '../Layout/Layout';
import { STEPS } from '../constants/steps';

const AccountDetailsForm = ({
  form,
  goToStep,
  errors,
  step,
  breadcrumbSteps,
  colors,
  sampleNotCustomizable,
  template,
  updateForm,
  skuData,
  cardSuiteDetails,
  isMagnet,
  isMulti,
  setMultiPreviewState,
  multiPreviewState,
  cardSuiteUUIDList,
  cardSuiteDetailsSet,
}) => {
  const { email, password } = form.account;

  const setField = key => event => updateForm({ account: { [key]: event.target.value } });

  return (
    <Layout.Form onSubmit={() => goToStep(STEPS.SAMPLE_PREVIEW)}>
      <Layout.Box>
        <Layout.Row>
          <Layout.PreviewBox>
            <SamplePreview
              hideColorPicker={sampleNotCustomizable}
              colors={colors}
              template={template}
              form={form}
              updateForm={updateForm}
              sampleNotCustomizable={sampleNotCustomizable}
              skuData={skuData}
              cardSuiteDetails={cardSuiteDetails}
              isMagnet={isMagnet}
              isMulti={isMulti}
              setMultiPreviewState={setMultiPreviewState}
              multiPreviewState={multiPreviewState}
              cardSuiteUUIDList={cardSuiteUUIDList}
              cardSuiteDetailsSet={cardSuiteDetailsSet}
            />
          </Layout.PreviewBox>
          <Layout.Col>
            <BreadCrumbs.Text step={step} breadcrumbSteps={breadcrumbSteps} />
            <Layout.Header>Almost there!</Layout.Header>
            <Layout.Text>
              Create an account, so we can save your draft and let you know when your sample ships
              (for free!).
            </Layout.Text>
            {errors && errors.account && errors.account.emailInUse && (
              <Banner type="error">{errors.account.emailInUse.errorMessage}</Banner>
            )}
            <Layout.Field
              required
              type="text"
              label="Email"
              input={{ name: 'email', value: email || '', onChange: setField('email') }}
            />
            <Layout.Field
              required
              type="password"
              label="Password"
              input={{ name: 'password', value: password || '', onChange: setField('password') }}
            />
            <Layout.FormButtons
              backLabel="Back"
              nextLabel="Preview Sample"
              nextDisabled={!email || !password}
              onBack={() => goToStep(STEPS.SHIPPING_DETAILS_FORM)}
            />
          </Layout.Col>
        </Layout.Row>
        <BreadCrumbs.Dots step={step} breadcrumbSteps={breadcrumbSteps} />
      </Layout.Box>
    </Layout.Form>
  );
};

export default AccountDetailsForm;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleFlowSteps/AccountDetailsForm.jsx